import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledBoxGeneric, StyledBoxDown, StyledButton } from './style';

import Modal from '../../../core/Modal';
import ModCurrentJob from './ModCurrentJob';
import ModExperienceItem from './ModExperienceItem';
import { moveElementPosition } from '../../../../utils/splices';
import { EXPERIENCE } from '../../../../constants/literals/modals';

class ModExperienceActual extends Component {
  constructor(props) {
    super(props);

    const data = props.dataCurrentPositions;

    this.state = {
      data,
      dataSavePastPositions: props.dataPastPositions,
      modalCurrentJob: false,
      position: null,
      currentCompany: ''
    };

    this.handleAccept = this.handleAccept.bind(this);
    this.handleReturn = this.handleReturn.bind(this);
  }

  onChangeDropDownInput = index => key => (month = false) => e => {
    const { data } = this.state;
    const dataRes = [...data];
    let date = e.value;

    if (month) {
      date = dataRes[index][key]
        ? `${dataRes[index][key].split('-')[0]}-${date}`
        : `-${date}`;
    } else {
      date = dataRes[index][key]
        ? `${date}-${dataRes[index][key].split('-')[1]}`
        : `${date}-`;
    }

    dataRes[index] = { ...dataRes[index], [key]: date };
    this.setState({ data: dataRes });
  };

  onClickExpand(index) {
    const { data } = this.state;
    const dataRes = [...data];
    dataRes[index] = { ...dataRes[index], expanded: !dataRes[index].expanded };
    this.setState({ data: dataRes });
  }

  onClickOrderArrow(index, isDown) {
    let { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    data = moveElementPosition(data.slice(), index, move);
    this.setState({ data });
  }

  onChangeChecked = (item, check) => {
    let valueMonth = new Date().getMonth() + 1;
    valueMonth = valueMonth > 9 ? `${valueMonth}` : `0${valueMonth}`;
    const position = {
      ...item,
      current: false,
      endDate: `${new Date().getFullYear()}-${valueMonth}`
    };
    this.setState({
      position,
      currentCompany: item.companyName,
      modalCurrentJob: !check
    });
  };

  getLabelMonth(date) {
    const { listMonths } = this.props;
    const defaultMonth = EXPERIENCE.MONTH;

    const month = date.split('-')[1];
    const label = month
      ? listMonths.find(objMonth => objMonth.value === month).text
      : defaultMonth;
    return label;
  }

  getLabelYear(date) {
    const { listYears } = this.props;
    const defaultYear = EXPERIENCE.YEAR;

    const year = date.split('-')[0];
    const label = year
      ? listYears.find(objYear => objYear.value === year).text
      : defaultYear;
    return label;
  }

  handleChange = index => key => e => {
    const { data } = this.state;
    const dataRes = [...data];
    dataRes[index] = { ...dataRes[index], [key]: e };
    this.setState({ data: dataRes });
  };

  handleChangeDescription = index => key => e => {
    const { data } = this.state;
    const dataRes = [...data];
    dataRes[index] = { ...dataRes[index], [key]: e };
    this.setState({ data: dataRes });
  };

  handleAccept() {
    const { onAcceptModal } = this.props;
    const {
      data,
      dataSavePastPositions,
      modalCurrentJob,
      position
    } = this.state;

    if (modalCurrentJob) {
      this.setState({
        data: data.filter(item => item.id !== position.id),
        dataSavePastPositions: [...dataSavePastPositions, position],
        modalCurrentJob: false,
        position: null
      });
    } else {
      onAcceptModal(this.state.data, this.state.dataSavePastPositions);
    }
  }

  handleReturn() {
    this.setState({
      modalCurrentJob: false,
      position: null
    });
  }

  render() {
    const { listMonths, listYears, onCloseModal } = this.props;
    const { data, modalCurrentJob, position, currentCompany } = this.state;

    return (
      <Modal title={EXPERIENCE.TITLE_MOD} clickCloseIcon={onCloseModal}>
        <StyledBoxGeneric>
          {modalCurrentJob ? (
            <ModCurrentJob
              listMonths={listMonths}
              listYears={listYears}
              company={currentCompany}
              onSelectUntilMonth={e => {
                const positionRes = {
                  ...position,
                  endDate: `${position.endDate.split('-')[0]}-${e.value}`
                };
                this.setState({ position: positionRes });
              }}
              onSelectUntilYear={e => {
                const positionRes = {
                  ...position,
                  endDate: `${e.value}-${position.endDate.split('-')[1]}`
                };
                this.setState({ position: positionRes });
              }}
              selectedUntilMonth={this.getLabelMonth(position.endDate)}
              selectedUntilYear={this.getLabelYear(position.endDate)}
            />
          ) : (
            data.map((item, index) => {
              const itemCallbackHandler = index => param => callback =>
                callback.bind(this, index, param);
              const getIndexItem = itemCallbackHandler(index);

              return (
                <ModExperienceItem
                  key={item.id}
                  companyName={item.companyName}
                  checkedCurrentWork={item.current}
                  expanded={item.expanded}
                  listMonths={listMonths}
                  listYears={listYears}
                  onChangeCheckbox={check => this.onChangeChecked(item, check)}
                  onChangeInputCompany={this.handleChange(index)('companyName')}
                  onChangeInputDescription={this.handleChangeDescription(index)(
                    'summary'
                  )}
                  onChangeInputPosition={this.handleChange(index)('title')}
                  onClickDown={getIndexItem(true)(this.onClickOrderArrow)}
                  onClickExpand={() => this.onClickExpand(index)}
                  onClickUp={getIndexItem(false)(this.onClickOrderArrow)}
                  onSelectFromMonth={this.onChangeDropDownInput(index)(
                    'startDate'
                  )(true)}
                  onSelectFromYear={this.onChangeDropDownInput(index)(
                    'startDate'
                  )(false)}
                  order={index}
                  selectedFromMonth={this.getLabelMonth(item.startDate)}
                  selectedFromYear={this.getLabelYear(item.startDate)}
                  summary={item.summary}
                  title={item.title}
                />
              );
            })
          )}
          <StyledBoxDown>
            {modalCurrentJob ? (
              <StyledButton onClick={this.handleReturn} modal>
                {EXPERIENCE.RETURN}
              </StyledButton>
            ) : (
              <StyledButton onClick={onCloseModal} modal>
                {EXPERIENCE.CANCEL}
              </StyledButton>
            )}
            <StyledButton onClick={this.handleAccept} secondary>
              {EXPERIENCE.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
        </StyledBoxGeneric>
      </Modal>
    );
  }
}

ModExperienceActual.propTypes = {
  dataCurrentPositions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      summary: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      companyName: PropTypes.string,
      current: PropTypes.bool,
      expanded: PropTypes.bool
    })
  ),
  dataPastPositions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      summary: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      companyName: PropTypes.string,
      current: PropTypes.bool,
      expanded: PropTypes.bool
    })
  ),
  listMonths: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  listYears: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)],
      id: PropTypes.oneOfType[(PropTypes.string, PropTypes.number)]
    })
  ),
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func
};

ModExperienceActual.defaultProps = {
  dataCurrentPositions: [],
  dataPastPositions: []
};

export default ModExperienceActual;
